import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingReportTableFilterComponent } from './fi-onboarding-report-table-filter/fi-onboarding-report-table-filter.component';
import { FiOnboardingReportTableFilterHelperService } from '@fi-app/fi-onboarding/fi-onboarding-report/shared/fi-onboarding-report-table-filter-helper.service';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { FiOnboardingReportSummaryChartComponent } from './fi-onboarding-report-summary-chart/fi-onboarding-report-summary-chart.component';
import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';
import { FiChartHistoryModule } from '@fi-shared/fi-chart-history/fi-chart-history.module';
import { FiOnboardingReportSummaryCardComponent } from './fi-onboarding-report-summary-card/fi-onboarding-report-summary-card.component';
import { MatCardModule } from '@angular/material/card';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        FiItemsListFilterModule,
        FiMenuMultiSelectItemSearchModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatCardModule,
        FiMenuItemSearchModule,
        FiReportPieChartModule,
        FiChartHistoryModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        InfoIconModule,
    ],
    declarations: [
        FiOnboardingReportTableFilterComponent,
        FiOnboardingReportSummaryChartComponent,
        FiOnboardingReportSummaryCardComponent,
    ],
    providers: [FiOnboardingReportTableFilterHelperService],
    exports: [
        FiOnboardingReportTableFilterComponent,
        FiOnboardingReportSummaryChartComponent,
        FiOnboardingReportSummaryCardComponent,
    ],
})
export class FiOnboardingReportSharedModule {}
